import { SvgIcon, SvgIconProps } from "@mui/material";

export const CreditCardIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M17.002 18.003V12a2 2 0 0 0-2-2H4.996a2 2 0 0 0-2 2v6.003a2 2 0 0 0 2 2h10.004a2 2 0 0 0 2.001-2Z"
        clip-rule="evenodd"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M2.996 14.08h14.006M6.198 10l1.21-4.523a1.997 1.997 0 0 1 2.451-1.41l9.664 2.59a1.997 1.997 0 0 1 1.41 2.452l-1.55 5.792a1.993 1.993 0 0 1-2.38 1.43"
      />
    </svg>
  </SvgIcon>
);
